import { render } from "./VehicleOptionsPriceTabComponent.vue?vue&type=template&id=08004a12&scoped=true"
import script from "./VehicleOptionsPriceTabComponent.vue?vue&type=script&lang=js"
export * from "./VehicleOptionsPriceTabComponent.vue?vue&type=script&lang=js"

import "./VehicleOptionsPriceTabComponent.vue?vue&type=style&index=0&id=08004a12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08004a12"]])

export default __exports__